


import { variantsMatch } from "./variantIdentity";

export function getAnalysisAnnotations(studySettings, studyBucket){

    const study = studyBucket.studies.find(s => s.localId === studySettings.id);

    if(study!== undefined){

        // get all the labelled ones;
        let analysis = study.analyses.find(s=> s.localId === studySettings.current_analysis);

        let global_labels = {"Important" : [], "Follow-Up": [], "Discarded":[], "Candidate": []}

        // make labels global so that are visible for all analyses run in the study.
        study.analyses.forEach(d => {
            if(d.labelled && Object.keys(d.labelled).length > 0 ){
                Object.keys(d.labelled).forEach(s => {
                    if (!global_labels[s]) {
                        global_labels[s] = [];
                    }
                    const incoming = d.labelled[s] || [];
                    incoming.forEach((variant) => {
                        const already = global_labels[s].some((stored) => variantsMatch(stored, variant));
                        if (!already) {
                            global_labels[s].push(variant);
                        }
                    });
                })
            }

        });

        if(analysis !== undefined){
            return {
                labelled: global_labels,
                tagged: (study.tagged_variants!== undefined) ? study.tagged_variants : []
            }
        }
        else{
            return {
                labelled: [],
                tagged: []
            }
        }
    }
    else{
        alert("Error: study not created");
    }
}


export function getStudy(studySettings, studyBucket){
    const study = studyBucket.studies.find(s => s.localId === studySettings.id);

    return {study:study}
}

export function canModifyStudy(studySettings, studyBucket, preferredName) {
    if (!studySettings.study_id_db) {
        return true;
    }

    const { study } = getStudy(studySettings, studyBucket);
    if (!study) {
        return false;
    }

    if (study.can_write === true) {
        return true;
    }

    if (study.creator === undefined) {
        return study.localId === studySettings.id;
    }

    return study.creator === preferredName;
}

export function getCurrentAnalysis(studySettings, studyBucket){
    const study = studyBucket.studies.find(s => s.localId === studySettings.id);

    if(study!== undefined && studySettings.current_analysis!== null){
        const analysis = study.analyses.find(s => s.localId === studySettings.current_analysis);

        /*if ((analysis.analysis_type == "instand") && (analysis.queries.length==2)){
            if (analysis.queries[0].outputs[0].n_variants === -1){
               analysis.queries.splice(0,1)
               analysis.queries[0].name = "query_1"}
        }*/

        if(analysis!== undefined){
            return {analysis:analysis}
        }
        else{
            return {analysis:false}
        }

    }
    else{
        return {analysis:false}
    }




}